<template>
    <div class="debug-page">
        <div v-for="row in data.rows">
            <h3>{{ row.name }}</h3>
            <div style="display: flex">
                <delivery-lead-single-debug :app_id="row.application_id" :delivery_lead_id="row.id" :key="row.id"></delivery-lead-single-debug>
                <delivery-agent-log-text-debug :app_id="1" :delivery_lead_id="data.logs[row.employer_id]"></delivery-agent-log-text-debug>
            </div>
        </div>
    </div>
</template>

<script>
import DeliveryLeadSingleDebug from "../../../delivery/Application/Tests/vue/delivery-lead-single-debug";
import DeliveryAgentLogTextDebug from "../../../delivery/Application/Tests/vue/delivery-agent-log-text-debug";

export default {
    components: {DeliveryAgentLogTextDebug, DeliveryLeadSingleDebug},
    props: [
        'data'
    ],
    data() {
        return {
        };
    },
    methods: {
    },
    mounted() {
    }
}
</script>